import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { GetAllServers } from "../../Api/Panel/GetAllServers";
import { GetMyActiveServers } from "../../Api/Panel/GetMyActiveServer";

export default function Serverspage() {
  const [serversData, setServersData] = useState([]);
  const [myserversData, setMyServersData] = useState([]);

  const Get = async () => {
    const { data } = await GetAllServers();
    setServersData(data);
  };
  const GetMy = async () => {
    const { data } = await GetMyActiveServers();
    setMyServersData(data);
  };

  useEffect(() => {
    Get();
    GetMy();
  }, []);

  return (
    <>
      <div className="flex col-span-4 xl:col-span-4 shadow-md border rounded-lg">
        <div className="py-8 px-5 w-full">
          <h2 className="text-xl lg:text-2xl text-center pb-6 w-full black-color">
            Servers List You Can Buy
          </h2>
          <div className="flex flex-col space-y-4">
            {/* L1 */}

            {serversData?.map((el, i) => (
              <div
                key={i}
                className="flex flex-col space-y-4 items-center justify-between text-center rounded-lg border border-gray-100 shadow text-white bg-gray-800 p-6 lg:space-y-0 lg:flex-row"
              >
                <div className="flex lg:text-left lg:w-[18%] items-center">
                  <h3 className="text-xl font-semibold">{el.title}</h3>
                  <h3 className=" pl-1 text-sm font-semibold">
                    ( {el.roleType})
                  </h3>
                </div>

                <p className="font-light sm:text-lg lg:w-[40%] text-center text-gray-400">
                  {el.desc}
                </p>
                <div className="flex items-center">
                  <span className="mr-1 text-2xl font-extrabold">
                    {el.bigPrice}
                  </span>
                  <span className="mr-1 text-sm font-extrabold">
                    {el.smallPrice}
                  </span>
                  <span className="text-sm text-gray-400">{el.month}</span>
                </div>
                <a
                  href={el.href}
                  className="text-white bg-primary-600 hover:bg-primary-700 focus:ring-4 focus:ring-primary-200 font-medium rounded-lg text-sm text-center  bg-[#3742fa] hover:bg-[#5352ed] p-2 focus:ring-primary-900"
                >
                  Get started
                </a>
              </div>
            ))}
          </div>
          <div className="relative flex py-8 items-center">
            <div className="flex-grow border-t border-gray-800"></div>
            <span className="flex-shrink text-xl lg:text-2xl mx-4 text-gray-800">
              Your Active Servers
            </span>
            <div className="flex-grow border-t border-gray-800"></div>
          </div>
          {/* L1 */}
          <div className="flex flex-col space-y-4">
            {myserversData?.map((el, i) => (
              <div
                key={i}
                className="flex flex-col space-y-4 items-center justify-between text-center rounded-lg border border-gray-100 shadow text-white bg-gray-800 p-6 lg:space-y-0 lg:flex-row"
              >
                <div className="flex items-center">
                  <h3 className="text-xl font-semibold">
                    Level {el.ServerLevel} Server
                  </h3>
                </div>

                <p className="font-light sm:text-lg text-gray-400">
                  {el.Servers}
                </p>
                <div className="flex items-center">
                  <span className="mr-1 text-xl font-extrabold">
                    {el.LeftDay === "" ? "0" : el.LeftDay} Days left
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
